import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpResponse } from '@angular/common/http';
import { ShellService } from '../../services/shell.service';

@Component({
  selector: 'app-file-download',
  templateUrl: './file-download.component.html',
  styleUrls: ['./file-download.component.scss'],
  standalone: true,
  providers: [ShellService],
})
export class FileDownloadComponent implements OnInit {
  private _route = inject(ActivatedRoute);
  private _shellService = inject(ShellService);
  blob!: Blob;
  engagementId!: string;
  fileId!: string;
  fileType!: string;
  isLoading: boolean = true;
  downloadMessage: string = '';

  constructor() { }

  ngOnInit(): void {
    this.engagementId = this._route.snapshot.params['id'] as string;
    this.fileId = this._route.snapshot.params['fileId'] as string;
    this.fileType = this._route.snapshot.params['type'] as string;
    this.downloadContract();
  }

  downloadContract(): void {
    this._shellService.downloadFileServiceById(this.engagementId, this.fileId, this.fileType)
      .subscribe({
        next: (response) => {
          const data = response.body as Blob;
          this.blob = new Blob([data], {
            type: 'application/octet-stream',
          });
          const fileName = this.getFileNameFromResponse(response) ?? this.fileId;
          let downloadUrl = window.URL.createObjectURL(this.blob);
          let link = document.createElement('a');
          link.href = downloadUrl;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(downloadUrl);
          this.downloadMessage = 'File downloaded successfully';
          this.isLoading = false;
        },
        error: (error) => {
          this.downloadMessage =
            'Error downloading file. Please contact iManageSupport@protiviti.com.';
          this.isLoading = false;
        },
        complete: () => { },
      });
  }

  private getFileNameFromResponse(response: HttpResponse<Blob>): string | null {
    const contentDisposition = response.headers.get('content-disposition');
    if (!contentDisposition) {
      return null;
    }

    const utf8Match = /filename\*=UTF-8''([^;]+)/i.exec(contentDisposition);
    if (utf8Match && utf8Match[1]) {
      return decodeURIComponent(utf8Match[1]);
    }

    const match = /filename="?([^";]+)"?/i.exec(contentDisposition);
    return match && match[1] ? match[1] : null;
  }
}
